__turbopack_context__.v({
  "root": "Contact-module-scss-module__-N7iRG__root",
});
